<template>
    <div class="flex-col">
        <label class="contact-info">{{item.peContactName}}<span style="font-weight: 400;">{{item.passed ? "": "（待审核，未发布）"}}</span></label> 
        <div class="flex-row deep-info">
            <span>关系深度: </span><span style="color:#D04a02">{{ item.relationDeepth}}</span> &nbsp;&nbsp;|&nbsp;&nbsp; 
            <span>{{ item.peOrganizationName}}</span><span v-if="item.responsibility != null">&nbsp;·&nbsp;</span>
            <span>{{ item.responsibility}}</span><span v-if="item.position != null">&nbsp;·&nbsp;</span><span>{{ item.position}}</span>
        </div>
        <div class="org-info"> 
            
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import commonStyle from '../../styles/common.scss';
    export default {
        name: 'RelationshipItem',
        props: {
            item: Object,
        },
        data() {
            return {};
        },
        created() {},
        methods: {},
    };
</script>


<style lang="scss" scoped>
    .detail-Info {
        height: calc(100% - 50px);
    }
    .contact-info {
        font-size: medium;
        font-weight: bold;
        padding: 0.5rem;
    }
    .deep-info {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        font-size: 14px;
        color: darkgray;
    }
    .org-info {
        padding: 0.5rem 0.5rem 1rem 0.5rem;
        font-size: 15px;
    }

</style>


// WEBPACK FOOTER //
// src/components/common/RelationshipItem.vue